import React, {Component, Fragment} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../../modules/SimpleInput";
import FlexView from "react-flexview";
import SimpleDate from "../../../../../modules/SimpleDate";
import InventoryUnitTable from "./InventoryUnitTable";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import InventoryPageStockInfo from "./InventoryPageStockInfo";
import M from "moment";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import {fetchCardStock} from "../service";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { defaultTableChange } from "../../../../../modules/custom/customTable";

class InventoryPageStock extends Component {
    tableConfig = [
        {
            name: this.props.type == 'hadiah' || this.props.type == 'otherItem' ? "date" : "stockCardDate",
            label: "Tanggal",
            options: {
                sort: false,
            },
        },
        {
            name: this.props.type == 'otherItem' ? "qtyBeggining" : "start",
            label: "Awal",
            options: {
                sort: false,
            },
        },
        {
            name: this.props.type == 'otherItem' ? "qtyTrxIn" : "in",
            label: "Masuk",
            options: {
                customBodyRender: (value, tableMeta) => {
                    return (
                        <a
                            className="btnAct"
                            style={{textDecoration: 'underline', color: 'blue'}}
                            onClick={() => this.handleUnitStockInfoModalVisibility(tableMeta.rowIndex, "TRX_IN")}
                        >
                            {value}
                        </a>
                    );
                }
            },
        },
        {
            name: this.props.type == 'otherItem' ? "qtyTrxOut" : "out",
            label: "Keluar",
            options: {
                customBodyRender: (value, tableMeta) => {
                    return (
                        <a
                            className="btnAct"
                            style={{textDecoration: 'underline', color: 'blue'}}
                            onClick={() => this.handleUnitStockInfoModalVisibility(tableMeta.rowIndex, "TRX_OUT")}
                        >
                            {value}
                        </a>
                    );
                }
            },
        },
        {
            name: this.props.type == 'otherItem' ? "qtyEnding" : "end",
            label: "Akhir",
            options: {
                sort: false,
            },
        },
    ]

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            unitStockInfoModalVisible: false,
            selectedData: null,
            dataTable: [],
            search: {
                startDate: M().format("DD-MM-YYYY"),
                endDate: M().format("DD-MM-YYYY"),
            },
            pagination: {
                count: 0,
                limit: 5,
                page: 1,
                orderBy: "id",
                sort: "ASC",
            },
            transactionType: null,
        }
    }

    componentDidMount = async () => {
        await this.fetchData();
    };

    fetchData = async () => {
        this.handleTriggerLoading();
        let {selectedData, kodeCabang, type, setError} = this.props;
        let request = {
            ...this.state.search,
            kodeKSU: selectedData?.kodeKSU,
            kodeLocator: selectedData?.kodeLocator,
            kodeCabang,
        };
        await fetchCardStock(
            type,
            this.setState.bind(this),
            request,
            setError,
            selectedData
        );
        this.handleTriggerLoading();
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({...prevValue, loading: !prevValue.loading}))
    };

    handleUnitStockInfoModalVisibility = (index, type) => {
        this.setState((prevValue) => ({
            ...prevValue,
            selectedData: {...prevValue.dataTable[index]},
            unitStockInfoModalVisible: !prevValue.unitStockInfoModalVisible,
            transactionType: type,
        }));
    }

    handleDateChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                [name]: M(value).format("DD-MM-YYYY"),
            },
        }));
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        return (
            <Fragment>
                <SimpleModal
                    title={this.props.pageConfig.stock.pageTitle}
                    visible={this.props.visible}
                    onClickClose={() => this.props.onClickClose()}
                    content={
                        <ModalContainer>
                            <div className="grid grid-2x grid-mobile-none gap-20px margin-bottom-20px">
                                <div id="grid-1">
                                    {this.props.pageConfig && this.props.pageConfig.stock.firstGrid.map(
                                        (field) => (
                                            <SimpleInput
                                                key={field.name}
                                                id={`input_text_${field.name}`}
                                                name={field.name}
                                                label={field.label}
                                                readOnly={true}
                                                value={this.props.selectedData[field.name]}
                                            />
                                        ))
                                    }
                                </div>

                                <div id="grid-2">
                                    {this.props.pageConfig && this.props.pageConfig.stock.secondGrid.map(
                                        (field) => (
                                            <SimpleInput
                                                key={field.name}
                                                id={`input_text_${field.name}`}
                                                name={field.name}
                                                label={field.label}
                                                readOnly={true}
                                                value={this.props.selectedData[field.name]}
                                            />
                                        ))
                                    }
                                </div>
                            </div>

                            <FlexView style={{justifyContent: "flex-end", gap: "10px"}}>
                                <SimpleDate
                                    id="select_start_date"
                                    nextdate
                                    date={this.state.search.startDate}
                                    maxDate={this.state.search.endDate}
                                    onChange={(value) => this.handleDateChange("startDate", value)}
                                />
                                <span className="margin-top-15px">s/d</span>
                                <SimpleDate
                                    id="select_end_date"
                                    backdate
                                    date={this.state.search.endDate}
                                    minDate={this.state.search.startDate}
                                    onChange={(value) => this.handleDateChange("endDate", value)}
                                />
                                <SimpleButton onClick={this.fetchData} className="margin-top-5px">Cari</SimpleButton>
                            </FlexView>
                            <SimpleDataTable
                              key={`${this.state.pagination.count}-${this.state.pagination.page}`}
                              data={this.state.dataTable}
                              columns={this.tableConfig}
                              toCount={this.state.pagination.count}
                              rowsPerPage={this.state.pagination.limit}
                              page={this.state.pagination.page - 1}
                              options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                            />
                            <div style={{textAlign: "right", marginTop: "10px"}}>
                                <SimpleButton
                                    onClick={() => this.props.onClickClose()}
                                    secondary
                                    text={"Kembali"}
                                />
                            </div>
                        </ModalContainer>
                    }
                />

                {this.state.unitStockInfoModalVisible && (
                    <InventoryPageStockInfo
                        setError={this.props.setError}
                        type={this.props.type}
                        transactionType={this.state.transactionType}
                        kodeCabang={this.props.kodeCabang}
                        kodeLocator={this.props.selectedData?.kodeLocator}
                        kodeKSU={this.props.selectedData?.kodeKSU}
                        pageConfig={this.props.pageConfig}
                        selectedData={this.state.selectedData}
                        selectedParentData={this.props.selectedData}
                        visible={this.state.unitStockInfoModalVisible}
                        onClickClose={this.handleUnitStockInfoModalVisibility}
                    />
                )}
                <SimpleLoadingOverlay active={this.state.loading}/>
            </Fragment>
        );
    }
}

export default InventoryPageStock;